export interface Testimonial {
  text: string;
  name: string;
  role: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'Compré MISTER PRO un domingo por la noche. El martes entré al campo con la sesión exacta planificada. Los chavales lo notaron desde el primer ejercicio. Espectacular.',
    name: 'Carlos M.',
    role: 'Entrenador Infantil · CD Valladolid'
  },
  {
    text: 'Pensé que era otro PDF teórico más. Pero esto es diferente. Las correcciones clave de cada ejercicio son oro puro. Nadie te enseña eso en los cursillos de entrenadores.',
    name: 'Raquel F.',
    role: 'Entrenadora Alevín · Madrid'
  },
  {
    text: 'Trabajo de lunes a viernes y entreno los fines de semana. El tiempo es lo que más me falta. Este sistema me ha devuelto los domingos. Ya no planifico desde cero. Solo ejecuto.',
    name: 'Laura G.',
    role: 'Coordinadora de Fútbol Base · Zaragoza'
  },
  {
    text: 'Al principio me pareció demasiado barato para ser bueno. Me equivoqué. La calidad del contenido está muy por encima del precio. Lo recomendaría a cualquier entrenador de base sin dudarlo.',
    name: 'Iñaki A.',
    role: 'Director Técnico · Club Deportivo Bilbao'
  },
  {
    text: 'Llevo el PDF en el móvil y lo consulto en el banquillo sin que nadie lo note. Es como tener un segundo entrenador al lado que te recuerda qué tienes que decir en cada momento.',
    name: 'Pablo C.',
    role: 'Entrenador Cadete · Murcia'
  },
  {
    text: 'Llevaba tres temporadas en Infantil sin saber si lo estaba haciendo bien. Con MISTER PRO por primera vez siento que hay un hilo conductor real en mis entrenamientos.',
    name: 'Sergio B.',
    role: 'Entrenador Infantil · Valencia'
  },
  {
    text: 'El Tomo 6 de gestión de padres me ha salvado la temporada. La reunión inicial con el guion que dan ahí eliminó el 90% de los problemas que tenía los años anteriores.',
    name: 'Marta R.',
    role: 'Entrenadora Juvenil · Sevilla'
  }
];
